import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { IResourceAuthorization } from '@verzekeringapp-mono/shared/src/models/resource_authorization'
import { getResourceAuthorization, getResourceAuthorizations } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import { useMemo } from 'react'
import Button from '~/components/Button'
import PolicySvg from '~/components/illustrations/Policy'
import CombilPolicyListItem from '~/screens/profile/select_combi_policy_screen/components/combi_policy_list_item'

export const ResourceAuthorizationsStep = ({
  setResourceAuthorization,
  currentResourceAuthorization,
  isLoading
}: {
  setResourceAuthorization: (resourceAuthorization: IResourceAuthorization) => void
  currentResourceAuthorization?: IResourceAuthorization | null
  isLoading: boolean
}) => {
  const resourceAuthorization = useAppSelector(getResourceAuthorization)
  const resourceAuthorizations = useAppSelector(getResourceAuthorizations)

  const mappedResourceAuthorizations = useMemo(() => {
    if (!resourceAuthorization && resourceAuthorizations) return resourceAuthorizations
    if (!resourceAuthorization) return []

    return [resourceAuthorization, ...resourceAuthorizations].filter(
      (resourceAuthorization) => resourceAuthorization !== null && resourceAuthorization !== undefined
    )
  }, [resourceAuthorizations, resourceAuthorization])

  const allResourceAuthorizationsInactive = useMemo(() => !currentResourceAuthorization?.active && resourceAuthorizations.every(ra => !ra.active), [currentResourceAuthorization, resourceAuthorizations])
  const allResourceAuthorizationsNew = useMemo(() => !currentResourceAuthorization?.seenAt && resourceAuthorizations.every(ra => !ra.seenAt), [currentResourceAuthorization, resourceAuthorizations])

  return (
    <div className='flex flex-col items-center px-4 md:w-1/2 mx-auto w-full'>
      {
        allResourceAuthorizationsInactive && (
          <FontAwesomeIcon
            icon='file-exclamation'
            className='mb-4 h-[100px] w-[100px] text-icon-secondary'
          />
        )
      }

      {
        !allResourceAuthorizationsInactive && (
          <PolicySvg />
        )
      }

      <p className='title mb-4 text-center'>
        {
          allResourceAuthorizationsInactive
            ? 'Verzekeringspakket inactief'
            : 'Welke combipolis?'
        }
      </p>

      <p className='description mb-4 text-center'>
        {
          allResourceAuthorizationsInactive
            ? 'Je verzekeringspakket is inactief. Toegang tot de VerzekeringApp en Mijn-Polissen.nl is daarmee niet mogelijk. Heb je vragen hierover? Neem contact op met je verzekeringsadviseur.'
            : 'Geen zorgen! Je kunt altijd weer een andere combipolis selecteren.'
        }
      </p>

      <div className='gap-2 flex flex-col'>
        {mappedResourceAuthorizations.map(resourceAuthorization => (
          <CombilPolicyListItem
            key={resourceAuthorization.id}
            resourceAuthorization={resourceAuthorization}
            current={!!currentResourceAuthorization && currentResourceAuthorization.id === resourceAuthorization.id}
            onPressSelect={resourceAuthorization => {
              setResourceAuthorization(resourceAuthorization)
            }}
            isNew={!resourceAuthorization.seenAt && !allResourceAuthorizationsNew}
          />
        ))}
      </div>

      <Button
        disabled={!currentResourceAuthorization || !currentResourceAuthorization.active || allResourceAuthorizationsInactive}
        className='w-full mt-8'
        type='submit'
        isLoading={isLoading}
      >
        Bevestigen
      </Button>
    </div>
  )
}
